<div *ngIf="!loading" class="signature-popup-container" #container fxLayout="column" fxLayoutGap="16px">
  <div class="title">
    <h2 class="title-popup-default-dark">DocuSign Signing</h2>
  </div>

  <div class="signing-overlay" *ngIf="signingUrl">
    <div class="signing-card">
      <iframe
        class="signing-frame"
        [src]="signingUrl"
        title="DocuSign Signing"></iframe>
    </div>
  </div>

  <div class="error" *ngIf="error">{{ error }}</div>
</div>
